exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".campaign-result-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 0;\n  flex-direction: column;\n}\n@media (max-width: 768px) {\n.campaign-result-header {\n    text-align: center;\n}\n}\n.campaign-result-header h3 {\n  font-weight: 500;\n}\n.campaign-result-header a {\n  color: #36b19e;\n  font-weight: bold;\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 1.2s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n", ""]);

// exports
